<template>
  <div class="bullets__container">
    <div class="bullets__content">
      <img
        class="bullets__content-image"
        :src="imagePath"
        :srcset="`${imagePath.replace(/(\.png)$/, '@2x$1')} 2x`"
        :alt="imageAlt"
      >
      <div>
        <Box mb="8">
          <Heading size="h2">
            {{ title }}
          </Heading>
        </Box>
        <ul class="bullets__list">
          <li v-for="(_, index) in $t(bulletKeys)" :key="index" class="bullets__list-item">
            <CheckBullet class="bullets__list-item-icon" />
            <div>
              <CustomText as-span weight="bold">
                <template v-if="titleUrls[index]">
                  <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
                  <Link :href="titleUrls[index]">{{ $t(`${bulletKeys}[${index}].title`) }}</Link>:
                </template>
                <template v-else>
                  <span>{{ $t(`${bulletKeys}[${index}].title`) }}</span>:
                </template>
              </CustomText>
              <CustomText as-span>
                <i18n
                  :path="`${bulletKeys}[${index}].description`"
                >
                  <template #link>
                    <Link :href="descriptionUrls[index]" target="_blank">
                      {{ $t(`${bulletKeys}[${index}].link`) }}
                    </Link>
                  </template>
                </i18n>
              </CustomText>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CheckBullet from './svg/CheckBullet'

import Box from '@/components/common/Box/Box'
import Heading from '@/components/common/Heading/Heading'
import CustomText from '@/components/common/CustomText/CustomText'
import Link from '@/components/common/Link/Link'

export default {
  components: {
    CheckBullet,
    Box,
    Heading,
    CustomText,
    Link
  },

  props: {
    title: {
      type: String,
      required: true
    },
    bulletKeys: {
      type: String,
      required: true
    },
    titleUrls: {
      type: Array,
      default: () => []
    },
    descriptionUrls: {
      type: Array,
      default: () => []
    },
    imagePath: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.bullets {
  &__container {
    padding: 0 $gap;
  }

  &__content {
    max-width: 1120px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    gap: $gap * 2;
    align-items: center;
    justify-content: center;
    padding: $gap * 5 0;

    @include display-less(desktop) {
      flex-direction: column-reverse;
    }

    &-image {
      max-width: 522px;

      @include display-less(hd) {
        max-width: 450px;
      }

      @include display-less(desktop) {
        max-width: 522px;
        width: 100%;
      }
    }
  }

  &__list {
    &-item {
      display: flex;
      flex-direction: row;
      gap: $gap;
      margin-bottom: $gap;

      &-icon {
        min-width: 24px;
      }
    }
  }
}
</style>
